import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import LogoReveal from "./components/LogoReveal";
import { ORG_SCHEMA } from "./components/Seo";

export default function MarketingLayout() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) { setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 60); return; }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  useEffect(() => {
    if (document.getElementById("ld-json-org")) return;
    const s = document.createElement("script"); s.type = "application/ld+json"; s.id = "ld-json-org";
    s.textContent = JSON.stringify(ORG_SCHEMA); document.head.appendChild(s);
  }, []);
  return (
    <div className="min-h-screen bg-light text-[#0A1628] flex flex-col">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:z-[60] focus:top-2 focus:left-2 focus:bg-white focus:px-3 focus:py-2 focus:rounded-md">Skip to content</a>
      <Header />
      <LogoReveal />
      <main id="main" className="flex-1"><Outlet /></main>
      <Footer />
    </div>
  );
}
